var videoSrc; 
// Grab src from data atribute on button
$('.js-modal-trigger.vid').on('click', function(e) {
    e.preventDefault();
    videoSrc = $(this).attr('data-src');
});

// Autoplay video when modal opens
$('#modalVideo').on('shown.bs.modal', function(e) {
    $('#modalVideoSrc').attr('src', videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
});

// Stop playing play video when modal closes
$('#modalVideo').on('hide.bs.modal', function(e) {
    $('#modalVideoSrc').attr('src', '');
});